// extracted by mini-css-extract-plugin
export default {"inativo":"MenuLateralCategoria_inativo__JAbwB"};